export default {
  defaultStyle: {
    '& button': {
      font: '14px Roboto, sans-serif',
      color: data => data.mainColor,
      bottom: '0',
      right: '0',
      maxWidth: '30%',
      position: 'absolute',
      padding: '3px 3px 3px 30px',
      '&:lang(ar)':{
        right: "auto",
        left: "0",
        paddingLeft: "3px",
        paddingRight: "30px"
      }
    }
  },
  preferencesSvg: {
    position: 'absolute',
    left: '0',
    top: '50%',
    width: '20px',
    height: '20px',
    marginTop: '-10px',
    '&:lang(ar)':{
      left: "auto",
      right: "0"
    }
  }
};
